import React from 'react';
import { P5CanvasInstance, ReactP5Wrapper } from '@p5-wrapper/react';
import { Walker } from './Walker';

class SimpleWalker extends Walker {

}

const SimpleWalkerComponent: React.FC = (props) => {
  function sketch(p5: P5CanvasInstance) {
    let walker: Walker;

    p5.setup = () => {
      p5.createCanvas(640, 240);
      p5.background(240);
      walker = new SimpleWalker(p5, p5.color(255, 0, 0));
    }

    p5.draw = () => {
      walker.step();
      walker.show();
    };
  }

  return <ReactP5Wrapper sketch={sketch} />;
};

export default SimpleWalkerComponent;